import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useForm } from "react-hook-form";
import showPassword from '../../../assets/Player_Portal/images/showPwrd.svg'
import hidePassword from '../../../assets/Player_Portal/images/hidePwrd.svg'
import Swal from "sweetalert2";

import { useResetPasswordMutation } from "../../../features/UserFeatures/UserResetPassword/UserResetPasswordSlice";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";

const ResetPassWord = () => {

  const [showHidePwrd, setShowHidePwrd] = useState(false);
  const [showConfPwrd, setShowConfPwrd] = useState(false);
  const [createPassword] = useResetPasswordMutation();
  const [loading, setLoading] = useState(false)


  const { register, handleSubmit, formState: { errors }, watch, reset, } = useForm()

  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const formal_token = urlParams.get("token");
  // let {token}  = useParams();
  const token = formal_token.replace(/ /g, '+')
  // console.log("tokenForFORGOT", token)

  useEffect(() => {
    //implement Reset API here
  })

  const email = localStorage.getItem("forgotEmail")
// console.log("emaillll",email)
  const onSubmit = async (data) => {



    // const {new_password, ...rest} = data;
    // console.log("email", email)
    // console.log('datagsdhfgydf',data)

    //   // return;
    //   const createPass = await createPassword({ email,...rest });
    //   console.log("createPass", createPass)




    const { before_password, ...rest } = data;
    // console.log("datataatat",data)
    setLoading(true);
    try {
      // return;
      const createPass = await createPassword({ email, token, ...rest });
      // console.log("createPass", createPass)

      if (createPass?.data?.status === 200) {
        reset({ before_password: "", newPassword: "" })
        Swal.fire({
          title: 'Success',
          type: 'success',
          text: createPass?.data?.message
        });
        // setState(true) 
        navigate("/login");
      }
      else {
        Swal.fire({
          title: 'Warning',
          type: 'warning',
          text: createPass?.data?.message,
        });
      }
    }
    catch (err) {
      Swal.fire({
        title: 'Error',
        type: 'Error',
        text: err,
      });
    }
    setLoading(false);

  }


  return (
    <>
      {loading && <Loader />}
      <div className='formWrapper'>
        <Container fluid className='h-100'>
          <Row className='h-100'>
            <Col xs={7} className='resetPassword p-0'>
            </Col>
            <Col>
              <div className='loginForm'>

                <form onSubmit={handleSubmit(onSubmit)} className="form-md">
                  <h4 className='welcomeText text-start mb-3'>Reset Password!</h4>
                  <Col>
                                        <div className="form-group custom-formGroup">
                                            <input
                                                id="password" onInput={(e) => e.target.value = e.target.value.trim()} type={showHidePwrd ? "text" : "password"} placeholder='Password' {...register("before_password", {
                                                    required: "*Enter password.", pattern: {
                                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#^&])[A-Za-z\d@$!%*?#^&]{8,}$/i,
                                                        message: "Need uppercase, lowercase and special characters with numbers."
                                                    },
                                                })}
                                            />
                                            <span className='inputIcon'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20.392" height="18.227" viewBox="0 0 21.392 21.227">
                                                    <path id="lock-svgrepo-com" d="M7.636,10.507c.571-.031,1.276-.031,2.182-.031h7.757c.906,0,1.61,0,2.182.031m-12.12,0a4.558,4.558,0,0,0-1.651.319,3.451,3.451,0,0,0-1.589,1.4C4,12.912,4,13.809,4,15.6v1.5c0,1.795,0,2.692.4,3.377a3.451,3.451,0,0,0,1.589,1.4c.778.349,1.8.349,3.832.349h7.757c2.036,0,3.054,0,3.832-.349A3.451,3.451,0,0,0,23,20.476c.4-.686.4-1.583.4-3.377V15.6c0-1.795,0-2.692-.4-3.377a3.451,3.451,0,0,0-1.589-1.4,4.558,4.558,0,0,0-1.651-.319m-12.12,0V8.34C7.636,5.391,10.349,3,13.7,3s6.06,2.391,6.06,5.34v2.167" transform="translate(-3 -2)" fill="none" stroke="#989898" />
                                                </svg>

                                            </span>

                                            <span className='showHide' onClick={() => { setShowHidePwrd(!showHidePwrd) }}>
                                                <img src={showPassword} className={showHidePwrd ? "d-none" : "d-block"} alt="Show Password" />
                                                <img src={hidePassword} className={showHidePwrd ? "d-block" : "d-none"} alt="Hide Password" />
                                            </span>
                                            {errors.before_password && <span role="alert">{errors.before_password.message}</span>}
                                        </div>

                                    </Col>
                                    <Col>
                                        <div className="form-group custom-formGroup">

                                            <input
                                                id="password" onInput={(e) => e.target.value = e.target.value.trim()} type={!showConfPwrd ? "password" : "text"} name="newPassword" placeholder='Confirm Password'{...register("newPassword", {
                                                    required: "*Enter confirm password.",
                                                    validate: (val) => {
                                                        if (watch('before_password') != val) {
                                                            return "Password and confirm password doesn't match.";
                                                        }
                                                    },
                                                })}

                                            />
                                            <span className='inputIcon'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20.392" height="18.227" viewBox="0 0 21.392 21.227">
                                                    <path id="lock-svgrepo-com" d="M7.636,10.507c.571-.031,1.276-.031,2.182-.031h7.757c.906,0,1.61,0,2.182.031m-12.12,0a4.558,4.558,0,0,0-1.651.319,3.451,3.451,0,0,0-1.589,1.4C4,12.912,4,13.809,4,15.6v1.5c0,1.795,0,2.692.4,3.377a3.451,3.451,0,0,0,1.589,1.4c.778.349,1.8.349,3.832.349h7.757c2.036,0,3.054,0,3.832-.349A3.451,3.451,0,0,0,23,20.476c.4-.686.4-1.583.4-3.377V15.6c0-1.795,0-2.692-.4-3.377a3.451,3.451,0,0,0-1.589-1.4,4.558,4.558,0,0,0-1.651-.319m-12.12,0V8.34C7.636,5.391,10.349,3,13.7,3s6.06,2.391,6.06,5.34v2.167" transform="translate(-3 -2)" fill="none" stroke="#989898" />
                                                </svg>
                                            </span>
                                            <span className='showHide' onClick={() => { setShowConfPwrd(!showConfPwrd) }} >
                                                <img src={showPassword} alt="Show Password" className={showConfPwrd ? "d-none" : "d-block"} />
                                                <img src={hidePassword} alt="Hide Password" className={showConfPwrd ? "d-block" : "d-none"} />
                                            </span>

                                            {errors.newPassword && <span role="alert">{errors.newPassword.message}</span>}
                                        </div>
                                    </Col>


                  <button className='btn btnSubmit mt-2' type="submit" >CONFIRM</button>


                </form>

              </div>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
};
export default ResetPassWord;












